import { useState } from "react";
import DataGrid from "./DataGrid/DataGrid.tsx";
import { PolicyDetails } from "../PolicyDetails/PolicyDetails.tsx";
import { VehiclePolicyMappingEnum } from "../../enum/normalization-mapping.enum.ts";

const VehiclePoliciesDataGrid = ({ clientPoliciesList, isLoading }) => {
  const [selectedPolicyId, setSelectedPolicyId] = useState<string | null>(null);

  const handleRowClick = ({ data }) => {
    setSelectedPolicyId(data[VehiclePolicyMappingEnum.POL_ID]);
  };

  const columns = [
    {
      name: VehiclePolicyMappingEnum.PolNum,
      header: "№ полица",
      minWidth: 140,
      type: "string",
    },
    {
      name: VehiclePolicyMappingEnum.InsComp,
      header: "ЗК",
      minWidth: 50,
      type: "string",
    },
    {
      name: VehiclePolicyMappingEnum.KindIns,
      header: "Тип",
      minWidth: 40,
      type: "string",
    },
    {
      name: VehiclePolicyMappingEnum.DKN,
      header: "Рег. №",
      minWidth: 50,
      type: "string",
    },
    {
      name: VehiclePolicyMappingEnum.Marka,
      header: "Марка",
      minWidth: 40,
      type: "string",
    },
    {
      name: VehiclePolicyMappingEnum.Engine,
      header: "Мощност",
      minWidth: 40,
      type: "string",
    },
    {
      name: VehiclePolicyMappingEnum.Year,
      header: "Година",
      minWidth: 40,
      type: "string",
    },
    {
      name: VehiclePolicyMappingEnum.EndDate,
      header: "Крайна дата",
      minWidth: 55,
      type: "date",
    },
  ];

  return (
    <>
      <DataGrid
        columns={columns}
        dataSource={clientPoliciesList}
        isLoading={isLoading}
        gridTitle="Полици на превозни средства"
        idProperty={VehiclePolicyMappingEnum.POL_ID}
        csvFilename="vehicle_policies.csv"
        onRowClick={handleRowClick}
        editable={false}
      />
      {selectedPolicyId && <PolicyDetails policyId={selectedPolicyId} />}
    </>
  );
};

export default VehiclePoliciesDataGrid;
